'use client';

import ForBrokersIcon from '@icons/ForBrokers.svg';
import RewardIcon from '@icons/reward.svg';
import TrendingIcon from '@icons/trend.svg';
import FmosHeroImage from '@images/use-cases/FmosImage.webp';
import { Containers, Widgets } from '@components';
import { CompanySubnav } from '@/components/elements/CompanySubnav';
import {
    FMOS_USE_CASES_WHY_HOW_BLOCKS,
    FMOS_USE_CASES_WHY_HOW_SECTION_TITLE,
} from '@/utils/content/fmosWhyHow';

export default function FieldMarketingOrganizationsPage() {
    return (
        <>
            <CompanySubnav section="use-cases" currentLabel="FMOs" />
            <Containers.Section
                el={
                    <Widgets.UseCasesHero
                        badge={{
                            iconSrc: ForBrokersIcon,
                            label: 'Designed for FMOs',
                        }}
                        title="FMOs: Field Marketing Organizations"
                        description="Predictable Benefits (PB) empowers Field Marketing Organizations (FMOs) to institutionalize their ICHRA offering, protecting their downline agents from disintermediation while creating a scalable, tech-forward recurring revenue stream."
                        secondaryDescription="Below are the key use cases for FMOs to offer ICHRAs using the PB platform to drive agent recruitment, retention, and market dominance."
                        image={{
                            src: FmosHeroImage,
                            alt: 'A smiling professional in a blue shirt at a desk in a bright office, writing in a notebook.',
                            priority: true,
                        }}
                        overlayCardsPositionClassName="bottom-[65%] right-3 md:bottom-[70%] md:right-4 lg:bottom-3 lg:right-3 lg:-translate-x-80"
                        overlayCards={[
                            {
                                title: 'Grow Your Agent Network',
                                subtitle:
                                    'Recruit and retain top-performing brokers',
                                iconSrc: TrendingIcon,
                                className: 'w-full max-w-[320px] shrink-0',
                            },
                            {
                                title: 'Own the Relationship',
                                subtitle: 'Stay at the center of every deal',
                                iconSrc: RewardIcon,
                                className: 'w-full max-w-[290px] shrink-0',
                            },
                        ]}
                    />
                }
            />
            <Containers.Section el={<Widgets.HeroOvalDivider color="brand-50" />} />
            <Containers.Section
                el={
                    <Widgets.UseCasesWhyHow
                        sectionTitle={FMOS_USE_CASES_WHY_HOW_SECTION_TITLE}
                        blocks={FMOS_USE_CASES_WHY_HOW_BLOCKS}
                        pillNavMode="fromBlocks"
                    />
                }
            />
            <Containers.Section
                el={<Widgets.ExploreOtherUseCases excludeSlug="fmos" />}
            />
            <Containers.Section el={<Widgets.ReadToBuild />} />
        </>
    );
}
